import { useState } from "react";
import { Truck, Megaphone, ShieldCheck, GraduationCap } from "lucide-react";
import { E } from "@/components/EditableText";
import { VendorDemo, MarketingDemo, TrainingDemo } from "@/slides/sections/S10b_TryIt";
import { OfacDemo } from "@/components/core/OfacDemo";

const SUN = "#F5B400";
const SUN_DEEP = "#C98F00";
const INK = "#0F1E2E";

const TABS = [
  { key: "vendor", label: "Vendor onboarding & monitoring", Icon: Truck, Demo: VendorDemo },
  { key: "marketing", label: "Marketing review", Icon: Megaphone, Demo: MarketingDemo },
  { key: "ofac", label: "OFAC checks", Icon: ShieldCheck, Demo: OfacDemo },
  { key: "training", label: "Training & tracking", Icon: GraduationCap, Demo: TrainingDemo },
];

export function SamplesSection() {
  const [tab, setTab] = useState("vendor");
  const Active = TABS.find((t) => t.key === tab)?.Demo || VendorDemo;

  return (
    <section id="samples" className="px-6 md:px-12 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <p className="pcp-mono text-[11px] mb-4" style={{ color: SUN_DEEP }}>/ Try it · live samples</p>
        <h2 className="pcp-h text-4xl md:text-5xl mb-6 max-w-4xl">
          <E k="samples.headline" defaultText="Don't take our word for it. Click around." as="span" multiline />
        </h2>
        <p className="text-base md:text-lg opacity-80 max-w-3xl mb-8 leading-relaxed">
          <E
            k="samples.intro"
            defaultText="These are working samples of the modules below — vendor onboarding, marketing review, OFAC screening, and tracked training. Run them right here. Your build is configured to your products, states, and partners."
            as="span"
            multiline
          />
        </p>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 mb-6">
          {TABS.map(({ key, label, Icon }) => {
            const on = tab === key;
            return (
              <button
                key={key}
                type="button"
                onClick={() => setTab(key)}
                data-testid={`sample-tab-${key}`}
                className="flex items-center gap-2 px-3 py-3 rounded-md text-left text-sm font-medium transition"
                style={{
                  background: on ? "rgba(245,180,0,0.15)" : "rgba(255,255,255,0.6)",
                  border: `1px solid ${on ? SUN : "rgba(15,30,46,0.10)"}`,
                  color: INK,
                }}
              >
                <Icon className="h-4 w-4 flex-shrink-0" style={{ color: SUN_DEEP }} strokeWidth={1.8} />
                <span className="leading-tight">{label}</span>
              </button>
            );
          })}
        </div>

        <div className="pcp-card p-4 md:p-6" data-testid="sample-demo-panel">
          <Active />
        </div>
      </div>
    </section>
  );
}
